import Vue from 'vue';
import Router from 'vue-router';

import menuComp from '@/app-components/menu-comp/menu-comp.vue';

Vue.use(Router);

export default new Router({
	routes: [{
			path: '/',
			name: 'login', // 登录页面
			component: () => import('@/views/login/login.vue')
		},
		{
			path: '/madt', // 副屏页面
			name: 'madt',
			component: () => import('@/views/madt.vue')
		},
		{
			path: '/nav',
			name: 'nav',
			redirect: '/nav/cashier',
			component: menuComp,
			children: [{
					path: 'cashier',
					name: 'cashier', // 收银页面
					component: () => import('@/views/cashier/cashier.vue'),
					meta: {
						keepAlive: true
					}
				},
				{
					path: 'commodity',
					name: 'commodity', // 商品管理页面
					component: () => import('@/views/commodity.vue')
				},
				{
					path: 'printd',
					name: 'printd', // 打印页面
					component: () => import('@/views/print/print.vue')
				},
				{
					path: 'order',
					name: 'order', // 订单页面
					component: () => import('@/views/order/order.vue')
				},
				{
					path: 'member',
					name: 'member',
					redirect: 'member/index',
					component: () => import('@/views/member/layout.vue'),
					children: [{
							path: 'index',
							name: 'memberList',
							component: () => import('@/views/member/index.vue')
						},
						{
							path: 'detail',
							name: 'memberDetail',
							component: () => import('@/views/member/detail.vue')
						}
					]
				},
				{
					path: 'shift',
					name: 'shift',
					component: () => import('@/views/shift/shift.vue')
				},
				{
					path: 'report',
					name: 'report',
					component: () => import('@/views/report.vue')
				},
				{
					path: 'system-set',
					name: 'systemSet',
					component: () =>
						import( /* webpackChunkName: "group-system-set" */
							'@/views/set/set.vue'),
					meta: {
						title: '系统设置 - 收银管理系统',
						name: '系统设置'
					}
				},
				
				{
					path: 'airecog',
					name: 'airecog', // ai识别页面
					component: () => import('@/views/airecog/airecog.vue')
				},
				
			]
		},
		{
			path: '/print',
			name: 'print',
			component: () => import( /* webpackChunkName: "group-print" */ '@/views/set/print.vue'),
			meta: {
				title: '标签打印 - 收银管理系统',
				name: '标签打印'
			}
		},
	]
});


// WEBPACK FOOTER //
// ./src/router/index.js